<template>
	<div>
		<router-view></router-view>
		<tabbar>
			<tabbar-item url="/home2/index" textcolor="red">
				<template v-slot:icon_select>
					<img src="../assets/img/home_select.png" />
				</template>
				<template v-slot:icon_unselect>
					<img src="../assets/img/home_unselect.png" />
				</template>
				<template v-slot:text>
					首页
				</template>
			</tabbar-item>
			<tabbar-item url="/home2/cart" textcolor="red">
				<template v-slot:icon_select>
					<img src="../assets/img/cart_select.png" />
				</template>
				<template v-slot:icon_unselect>
					<img src="../assets/img/cart_unselect.png" />
				</template>
				<template v-slot:text>
					购物车
				</template>
			</tabbar-item>
			<tabbar-item url="/home2/profile" textcolor="red">
				<template v-slot:icon_select>
					<img src="../assets/img/profile_select.png" />
				</template>
				<template v-slot:icon_unselect>
					<img src="../assets/img/profile_unselect.png" />
				</template>
				<template v-slot:text>
					我的
				</template>
			</tabbar-item>
			<tabbar-item url="/home2/find" textcolor="red">
				<template v-slot:icon_select>
					<img src="../assets/img/find_select.png" />
				</template>
				<template v-slot:icon_unselect>
					<img src="../assets/img/find_unselect.png" />
				</template>
				<template v-slot:text>
					发现
				</template>
			</tabbar-item>
		</tabbar>
		
	</div>
	
</template>

<script>
	import Tabbar from '../components/tabbar/Tabbar.vue'
	import TabbarItem from '../components/tabbar/Tabbar-Item.vue'
	
	export default {
		
		components:{
			Tabbar,
			TabbarItem
		}
	}
</script>

<style>
</style>
